import { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';

import Canonical from 'Components/Canonical';
import { List, Points } from 'Components/LandingPages/SafetyInfo';

import { getRouterBasePath } from 'utils/meta';

const Breadcrumbs = dynamic(
  () => import('Components/Dumb/Breadcrumbs').then(module => module.default),
  { ssr: true },
);

const SafetyInformation = ({ list }) => {
  const safetyData = list.map(e => e.title);

  const { title, description } = getRouterBasePath('/safety-information');
  const [scrollViewTarget, setScrollViewTarget] = useState(null);

  return (
    <>
      <Canonical />
      <NextSeo title={title} description={description} />
      <Container>
        <Row>
          <Col
            xs={12}
            sm={12}
            lg={{ offset: 2, size: 8 }}
            xl={{ offset: 2, size: 8 }}
          >
            <Breadcrumbs roadMap="home.safety-information" />
            <Row className="nested-grid--row">
              <Col sm={12} md={3}>
                <Points
                  data={safetyData}
                  setScrollTarget={v => setScrollViewTarget(v)}
                />
              </Col>
              <Col sm={12} md={9}>
                <List data={list} scrollView={scrollViewTarget} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};
SafetyInformation.getInitialProps = async () => ({
  list: [
    {
      title: 'safety_information_title_1',
      description: 'safety_information_description_1',
      imgSrc: '/images/MeetingUp/Artboard.png',
      link: 'safety_information_link_text_1',
    },
    {
      title: 'safety_information_title_2',
      description: 'safety_information_description_2',
      imgSrc: '/images/MeetingUp/ArtboardCopy2.png',
      link: 'safety_information_link_text_2',
    },
    {
      title: 'safety_information_title_3',
      description: 'safety_information_description_3',
      imgSrc: '/images/MeetingUp/ArtboardCopy3.png',
      link: 'safety_information_link_text_3',
    },
    {
      title: 'safety_information_title_4',
      description: 'safety_information_description_4',
      imgSrc: '/images/MeetingUp/ArtboardCopy4.png',
      link: 'safety_information_link_text_4',
    },
    {
      title: 'safety_information_title_5',
      description: 'safety_information_description_5',
      imgSrc: '/images/MeetingUp/ArtboardCopy5.png',
      link: 'safety_information_link_text_5',
    },
    {
      title: 'safety_information_title_6',
      description: 'safety_information_description_6',
      imgSrc: '/images/MeetingUp/ArtboardCopy6.png',
      link: 'safety_information_link_text_6',
    },
    {
      title: 'safety_information_title_7',
      description: 'safety_information_description_7',
      imgSrc: '/images/MeetingUp/ArtboardCopy7.png',
      link: 'safety_information_link_text_7',
    },
    {
      title: 'safety_information_title_8',
      description: 'safety_information_description_8',
      imgSrc: '/images/MeetingUp/ArtboardCopy8.png',
      link: 'safety_information_link_text_8',
    },
    {
      title: 'safety_information_title_9',
      description: 'safety_information_description_9',
      imgSrc: '/images/MeetingUp/ArtboardCopy9.png',
      link: 'safety_information_link_text_9',
    },
    {
      title: 'safety_information_title_10',
      description: 'safety_information_description_10',
      imgSrc: '/images/MeetingUp/ArtboardCopy10.png',
      link: 'safety_information_link_text_10',
    },
  ],
});
export default SafetyInformation;
